import React from 'react';
import { Link } from 'react-router-dom';
import './WHMCS.css';

const WHMCS = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const whmcsServices = [
    {
      icon: '🛒',
      title: 'خرید لایسنس WHMCS',
      desc: 'خرید لایسنس رسمی و اورجینال WHMCS با بهترین قیمت. لایسنس‌های WHMCS شامل پشتیبانی رسمی، به‌روزرسانی خودکار و امکان نصب روی سرورهای لینوکس و ویندوز می‌باشند.',
      features: ['لایسنس اورجینال', 'پشتیبانی رسمی', 'به‌روزرسانی خودکار', 'نصب رایگان'],
      link: '/whmcs/license',
      color: '#06B6D4',
    },
    {
      icon: '⚙️',
      title: 'نصب و کانفیگ WHMCS',
      desc: 'خدمات حرفه‌ای نصب و راه‌اندازی WHMCS روی سرورهای لینوکس و ویندوز. شامل نصب کامل، کانفیگ امنیتی، تنظیمات بهینه، نصب قالب و ماژول‌های مورد نیاز.',
      features: ['نصب کامل', 'کانفیگ امنیتی', 'تنظیمات بهینه', 'پشتیبانی ۲۴/۷'],
      link: '/whmcs/install',
      color: '#F97316',
    },
    {
      icon: '🧩',
      title: 'ماژول WHMCS',
      desc: 'توسعه و نصب ماژول‌های اختصاصی WHMCS برای هاستینگ، دامنه، سرور و سرویس‌های مختلف. ماژول‌های WHMCS قابلیت اتصال به cPanel، DirectAdmin، Plesk، Virtualizor و سایر سیستم‌ها را دارند.',
      features: ['توسعه اختصاصی', 'اتصال به cPanel', 'اتصال به DirectAdmin', 'پشتیبانی کامل'],
      link: '/whmcs/modules',
      color: '#8B5CF6',
    },
    {
      icon: '💳',
      title: 'ماژول درگاه پرداخت WHMCS',
      desc: 'اتصال درگاه‌های پرداخت ایرانی و بین‌المللی به WHMCS. پشتیبانی از درگاه‌های زرین‌پال، پارسیان، ملت، سامان، پاسارگاد و همچنین PayPal، Stripe و سایر درگاه‌های بین‌المللی.',
      features: ['درگاه‌های ایرانی', 'درگاه‌های بین‌المللی', 'امنیت بالا', 'نصب حرفه‌ای'],
      link: '/whmcs/payment-gateway',
      color: '#22C55E',
    },
    {
      icon: '🎨',
      title: 'قالب WHMCS',
      desc: 'طراحی و توسعه قالب‌های اختصاصی WHMCS با ظاهری زیبا و حرفه‌ای. قالب‌های ریسپانسیو، سازگار با موبایل و بهینه شده برای سئو.',
      features: ['طراحی اختصاصی', 'ریسپانسیو', 'سئو شده', 'شخصی‌سازی'],
      link: '/whmcs/template',
      color: '#EC4899',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>خدمات WHMCS | خرید لایسنس، نصب، ماژول، درگاه پرداخت و قالب | افراسل</h1>
        <p>خدمات تخصصی WHMCS شامل خرید لایسنس اورجینال، نصب و کانفیگ حرفه‌ای، توسعه ماژول‌های اختصاصی، اتصال درگاه‌های پرداخت ایرانی و بین‌المللی و طراحی قالب. پشتیبانی ۲۴ ساعته و بهترین قیمت.</p>
        <meta name="description" content="خدمات تخصصی WHMCS در افراسل. خرید لایسنس اورجینال WHMCS، نصب و کانفیگ، ماژول‌های اختصاصی، درگاه‌های پرداخت و قالب‌های حرفه‌ای. پشتیبانی ۲۴/۷ و بهترین قیمت." />
      </div>

      <section className="whmcs-hero">
        <div className="whmcs-hero-bg"></div>
        <div className="wrap">
          <div className="whmcs-hero-content">
            <div className="whmcs-badge">
              <span className="pulse-dot"></span>
              🛒 خدمات تخصصی WHMCS
            </div>
            <h1 className="whmcs-hero-title">
              خدمات <em>WHMCS</em> حرفه‌ای
            </h1>
            <p className="whmcs-hero-desc">
              WHMCS یک سیستم مدیریت کسب‌وکار آنلاین برای ارائه‌دهندگان خدمات هاستینگ، دامنه و سرور است. 
              این سیستم قدرتمند به شما امکان می‌دهد تا تمام فرآیندهای کسب‌وکار خود را از ثبت‌نام مشتریان، صدور فاکتور، 
              مدیریت خدمات، پشتیبانی و اتوماسیون را به سادگی مدیریت کنید.
            </p>
            <div className="whmcs-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۵+</span>
                <span className="stat-label">خدمات WHMCS</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰+</span>
                <span className="stat-label">پروژه موفق</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whmcs-services">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">خدمات WHMCS</span>
            <h2 className="sec-h">خدمات <em>تخصصی WHMCS</em></h2>
            <p className="sec-p">از خرید لایسنس تا نصب، کانفیگ، توسعه ماژول، اتصال درگاه پرداخت و طراحی قالب، همه خدمات WHMCS را با بهترین کیفیت در افراسل دریافت کنید.</p>
          </div>
          <div className="whmcs-services-grid">
            {whmcsServices.map((service, i) => (
              <Link to={service.link} key={i} className="whmcs-service-card">
                <span className="whmcs-service-icon">{service.icon}</span>
                <h3 className="whmcs-service-title">{service.title}</h3>
                <p className="whmcs-service-desc">{service.desc}</p>
                <ul className="whmcs-service-features">
                  {service.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <span className="whmcs-service-link" style={{ color: service.color }}>
                  مشاهده جزئیات ←
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="whmcs-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              خدمات <em>WHMCS</em> را با افراسل تجربه کنید
            </h2>
            <p className="cta-desc">
              با استفاده از خدمات تخصصی WHMCS در افراسل، کسب‌وکار خود را به سطح بالاتری ببرید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
              <button className="btn-lg ghost" onClick={() => {
                const el = document.querySelector('.whmcs-services-grid');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}>
                مشاهده خدمات
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WHMCS;
